import i18n from '../i18n';

export const $ = (id) => document.getElementById(id);

export const scrollTop = (targetId, smooth = true) => {
  if (targetId) {
    $(targetId).scrollIntoView({ behavior: smooth ? 'smooth' : 'auto' });
  } else {
    if (smooth) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome
    }
  }
};

export const scrollBottom = (id) => {
  const el = $(id);
  el.scrollTop = el.scrollHeight;
};

export const setDocTitle = (title) => {
  document.title = `${title} | Migrupo`;
};

export const getRemainingDays = (date) => {
  const d = new Date(date);
  const today = new Date();
  const oneDay = 24 * 60 * 60 * 1000;

  const remainingDays = Math.ceil((d.getTime() - today.getTime()) / oneDay);

  return remainingDays;
};

// getRemainingDays in words, as the service card's tag reads it
export const getRemainingDaysLabel = (remainingDays) => {
  if (remainingDays > 1) return i18n.t('time.inDays', { count: remainingDays });
  if (remainingDays === 1) return i18n.t('time.tomorrow');
  if (remainingDays === 0) return i18n.t('time.today');
  if (remainingDays === -1) return i18n.t('time.yesterday');
  return i18n.t('time.daysAgo', { count: Math.abs(remainingDays) });
};

/**
 * Sorts services array to put past services at the bottom (reversed chronologically)
 * and upcoming/current services at the top (chronologically)
 * @param {Array} servicesData - Array of service objects with date property
 * @returns {Array} - Sorted services array
 */
export const sortPastServices = (servicesData) => {
  const pastServices = [];
  const otherServices = [];

  for (const service of servicesData) {
    if (getRemainingDays(service.date) < 0) {
      pastServices.push(service);
    } else {
      otherServices.push(service);
    }
  }

  pastServices.reverse();

  return [...otherServices, ...pastServices];
};
